import React from 'react';
import { Button, Result } from 'antd';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '@/routes';
import styles from './NotFound.module.scss';

export const NotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className={styles.page}>
      <Result
        status="404"
        title="Page not found"
        subTitle="That link doesn't lead anywhere. It may have moved, or the address is wrong."
        extra={
          <Button type="primary" onClick={() => navigate(ROUTES.SESSIONS, { replace: true })}>
            Go to Sessions
          </Button>
        }
      />
    </div>
  );
};

export default NotFound;
